import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ViewEncapsulation, OnChanges, ViewChild } from '@angular/core';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Dropdown } from 'primeng/primeng';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { JsonSchemaPropertiesFormFieldsProperties, JsonSchemaPropertiesFormFieldsRadioOptions } from '../../models/campaign-3.model';
import { AuthService } from 'app/services/user/auth.service';

@Component({
  selector: 'app-form-fields',
  templateUrl: './form-fields.component.html',
  styleUrls: ['./form-fields.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FormFields implements OnInit, OnChanges {

  @ViewChild(Dropdown) dropdown: Dropdown;

  @Input() readOnly: boolean = false;
  @Input() fieldSchema: JsonSchemaPropertiesFormFieldsProperties;
  @Input() type: string = "";
  @Input() minValue: number = null;
  @Input() maxValue: number = null;
  @Input() minLength: number = null;
  @Input() maxLength: number = null;
  @Input() required: boolean = null;
  @Input() pattern: string = null;
  @Input() visible: boolean = null;
  @Input() default: any = null;
  @Input() label: string = null;
  @Input() step: number = null;
  @Input() name: string = null;
  @Input() disabled: boolean = null;
  @Input() fieldModel: any = null;
  @Input() minDate: Date = null;
  @Input() filterable: boolean = null;
  @Input() maxDate: Date = null;
  @Input() showRequiredAsterix: boolean = true;
  @Input() showLabel: boolean = true;
  @Input() serverOptions = {
    service: null,
    methodName: "",
    filterField: "",
    filterValue: null,
    groupByField: "",
    groupedFieldArray: {fieldName: '', newFieldName: ''}
  }

  //GF view default value in dropdown
  @Input() dataKey: string = null;

  //per gestione dropdown
  @Input() placeholder: string = "";
  @Input() options: any = [];
  @Input() optionLabel: string = "Seleziona...";

  valid: boolean = true;
  errorMessage: string = "";
  show = {
    element: false
  }

  language: string = "it";
  radioOptions: Array<JsonSchemaPropertiesFormFieldsRadioOptions>;

  @Output() fieldModelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkboxChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterDropdownChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() optionsDropdownChanged: EventEmitter<any> = new EventEmitter<any>();


  // Dichiara un Subject per gestire gli eventi di input durante la ricerca di una parola in una combo con chiamata a server
  private inputSubject = new Subject<string>();

  constructor(
    public srvCalendar: CalendarTranslateService, private authService: AuthService
  ) {

    // Applica il debounce alla sottoscrizione agli eventi di input
    this.inputSubject.pipe(
      debounceTime(300) // Ritardo di 300 millisecondi
    ).subscribe(value => {
      this.customFilterFunction(value);
    });

  }

  ngOnChanges(changes: SimpleChanges): void {


    /*
        if (changes['fieldModel'] && changes['fieldModel'].previousValue!=changes['fieldModel'].currentValue) {
          this.fieldModelChange.emit(changes['fieldModel'].currentValue);
        }
        */
  }

  // La tua funzione per la gestione degli eventi di input
  onInputChange(value: string) {
    if (this.serverOptions && this.serverOptions.service) {
      // Invia il valore al Subject per attivare il debounce
      this.inputSubject.next(value);

    }
  }

  modelChanged(value: any) {

    /*
    if(typeof event === 'object'){
      this.fieldModelChange.emit(this.fieldModel);
    }
    */

    this.fieldModelChange.emit(value);

  }

  ngOnInit() {

    this.initAll();
  }

  //serverOptionsFilter per usarlo la funzione deve accettare parametri
  @Input() serverOptionsFilter: any;

  initAll() {
    this.show.element = false;
    var self = this
    this.language = this.authService.sessionHelper.selectedLanguage;
    //CHIAMATE NON PARAMETRICHE
    if (this.type == "dropdown" && this.serverOptions.service && this.serverOptions.methodName && !this.serverOptionsFilter) {
      const methodName = this.serverOptions.methodName;
      // Verifica che il metodo esista nel servizio
      if (typeof this.serverOptions.service[methodName] === 'function') {

        this.serverOptions.service[methodName]().subscribe(res => {

          if (res && res.data && res.data.length > 0) {

            if (self.serverOptions.groupByField && self.serverOptions.groupByField != "" && self.serverOptions.groupedFieldArray && self.serverOptions.groupedFieldArray.fieldName && self.serverOptions.groupedFieldArray.newFieldName) {

              // Raggruppa i dati secondo il campo specificato
              self.groupResults(res);
              // self.show.element = true;
              self.optionsDropdownChanged.emit(self.options);
            }
          } else {
            self.options = [];
            // self.show.element = true;
          }

          self.checkFieldSchema();
          self.checkReadOnly();
          self.checkNullFields();
          // self.checkDefault();
          self.checkDropdownFieldOptions();
          self.checkDefault();
          self.show.element = true;

        });
      } else {
        console.error(`La funzione ${methodName} non esiste nel servizio.`);
      }
    }
    //CHIAMATE PARAMETRICHE
    else if (this.type == "dropdown" && this.serverOptions.service && this.serverOptions.methodName && this.serverOptionsFilter) {
      const methodName = this.serverOptions.methodName;
      // Verifica che il metodo esista nel servizio
      if (typeof this.serverOptions.service[methodName] === 'function') {
        //per questo tipo di chiamata con filtro la funzione chiamata deve per forza accettare dei parametri!!!!
        this.serverOptions.service[methodName](this.serverOptionsFilter).subscribe(res => {
          if (res && res.data && res.data.length > 0) {

            if (self.serverOptions.groupByField && self.serverOptions.groupByField != "" && self.serverOptions.groupedFieldArray && self.serverOptions.groupedFieldArray.fieldName && self.serverOptions.groupedFieldArray.newFieldName) {

              // Raggruppa i dati secondo il campo specificato
              self.groupResults(res);
              // self.show.element = true;
              self.optionsDropdownChanged.emit(self.options);
            }
          } else {
            self.options = [];
            // self.show.element = true;
          }

          self.checkFieldSchema();
          self.checkReadOnly();
          self.checkNullFields();
          // self.checkDefault();
          self.checkDropdownFieldOptions();
          self.checkDefault();
          self.show.element = true;

        });
      } else {
        console.error(`La funzione ${methodName} non esiste nel servizio.`);
      }
    } else {
      this.checkFieldSchema();
      this.checkReadOnly();
      this.checkNullFields();

      this.checkDropdownFieldOptions();
      this.checkDefault();
      setTimeout(function () {
        self.show.element = true;
      }, 100);
    }

  }

  checkDropdownFieldOptions() {

    if (this.type == "dropdown" && this.fieldSchema && this.fieldSchema.options && this.fieldSchema.options.length > 0) {
      this.options = [];
      for (let opt of this.fieldSchema.options) {
        if (('value' in opt) && ('label' in opt) && ('it' in opt.label)) {
          this.options.push({value: opt.value, label: opt.label[this.language]});
        }
      }
      this.optionLabel = "label";
    }
  }

  checkFieldSchema() {
    if (this.fieldSchema) {
      this.type = this.fieldSchema.type;
      this.options = this.options != null ? this.options : (this.fieldSchema.options ? this.fieldSchema.options : this.options);
      this.default = this.default != null ? this.default : (this.fieldSchema.default ? this.fieldSchema.default : this.default);
      this.required = this.required != null ? this.required : (this.fieldSchema.required ? this.fieldSchema.required : this.required);
      this.disabled = this.disabled != null ? this.disabled : (this.fieldSchema.disabled ? this.fieldSchema.disabled : this.disabled);
     this.maxValue =
  this.maxValue != null
    ? Number(this.maxValue)
    : (this.fieldSchema.maxValue != null
        ? Number(this.fieldSchema.maxValue)
        : null);

this.minValue =
  this.minValue != null
    ? Number(this.minValue)
    : (this.fieldSchema.minValue != null
        ? Number(this.fieldSchema.minValue)
        : null);

      this.minLength = this.minLength != null ? this.minLength : (this.fieldSchema.minLength ? this.fieldSchema.minLength : this.minLength);
      this.maxLength = this.maxLength != null ? this.maxLength : (this.fieldSchema.maxLength ? this.fieldSchema.maxLength : this.maxLength);
      this.minDate = this.minDate != null ? this.minDate : (this.fieldSchema.minDate ? this.fieldSchema.minDate : this.minDate);
      this.maxDate = this.maxDate != null ? this.maxDate : (this.fieldSchema.maxDate ? this.fieldSchema.maxDate : this.maxDate);
      this.step = this.step != null ? this.step : (this.fieldSchema.step ? this.fieldSchema.step : this.step);
      this.name = this.name != null ? this.name : (this.fieldSchema.name ? this.fieldSchema.name : this.name);
      this.pattern = this.pattern != null ? this.pattern : (this.fieldSchema.pattern ? this.fieldSchema.pattern : this.pattern);
      this.visible = this.visible != null ? this.visible : (this.fieldSchema.visible == false ? false : this.visible);
      this.filterable = this.filterable != null ? this.filterable : (this.fieldSchema.filterable ? this.fieldSchema.filterable : this.filterable);

      if (this.fieldSchema.label) {
        this.label = this.label != null ? this.label : this.fieldSchema.label[this.language];
      }
      if (this.fieldSchema.type == 'radio' && this.fieldSchema.radioOptions && this.fieldSchema.radioOptions.length > 0) {
        this.radioOptions = this.fieldSchema.radioOptions;
      }
    }
  }

  checkReadOnly() {
    if (this.readOnly == true) {
      this.disabled = true;
    }
  }

  onCheckboxChange(value: any) {
    this.checkboxChanged.emit(value);
  }

  checkNullFields() {

    if (this.readOnly == null)
      this.readOnly = false;

    if (this.required == null)
      this.required = false;

    if (this.visible == null)
      this.visible = true;

    if (this.default == null)
      this.default = "";

    if (this.name == null)
      this.name = "";

    if (this.label == null)
      this.label = "";

    if (this.disabled == null)
      this.disabled = false;

    if (this.showLabel == null)
      this.showLabel = true;

    if (this.showRequiredAsterix == null)
      this.showRequiredAsterix = true;
  }

  checkDefault() {

    if (!this.fieldModel && this.default != null && this.default != "") {

      if (this.type == "dropdown" && this.options && this.options.length > 0) {

        this.fieldModel = this.options.find(x => x.value == this.default);

      } else {
        this.fieldModel = this.default;
      }

      this.fieldModelChange.emit(this.fieldModel);
    }
  }

  customFilterFunction(event: any) {
    if (event && (event.value == null || event.value.length >= 3 || event.value.length == 0)) {


      const methodName = this.serverOptions.methodName;
      const field = this.serverOptions.filterField;
      // Verifica che il metodo esista nel servizio
      if (typeof this.serverOptions.service[methodName] === 'function') {
        var self = this
        // Chiamata alla funzione del servizio con parametri
        let search = [
          {key: field, value: event.value}
        ];

        this.serverOptions.service[methodName](null, null, search).subscribe(res => {
          if (res && res.data && res.data.length > 0) {

            if (self.serverOptions.groupByField && self.serverOptions.groupByField != "" && self.serverOptions.groupedFieldArray && self.serverOptions.groupedFieldArray.fieldName && self.serverOptions.groupedFieldArray.newFieldName) {
              self.groupResults(res);
            }
          } else {
            self.options = [];
          }
          self.filterDropdownChanged.emit(event.value);
        });
      } else {
        console.error(`La funzione ${methodName} non esiste nel servizio.`);
      }
    }
  }

  showDropdown() {
    if (this.dropdown && this.dropdown.overlayVisible === false) {
      this.dropdown.show();
    }
  }

  groupResults(res: any) {
    // Raggruppa i dati secondo il campo specificato
    const groupedData = res.data.reduce((acc, curr) => {
      const key = curr[this.serverOptions.groupByField]; // Utilizza il campo desiderato per il raggruppamento

      const existingGroup = acc.find(item => item[this.serverOptions.groupByField] === key);
      if (existingGroup) {
        if (!existingGroup[this.serverOptions.groupedFieldArray.newFieldName].includes(curr[this.serverOptions.groupedFieldArray.fieldName])) {
          existingGroup[this.serverOptions.groupedFieldArray.newFieldName].push(curr[this.serverOptions.groupedFieldArray.fieldName]); // Aggiungi il valore all'array se non presente
        }
      } else {
        const newGroup = {
          [this.serverOptions.groupByField]: key,
          [this.serverOptions.groupedFieldArray.newFieldName]: [curr[this.serverOptions.groupedFieldArray.fieldName]], // Inizializza l'array con il primo valore
        };
        // Copia tutti gli altri campi dell'oggetto originale nell'elemento raggruppato
        Object.keys(curr).forEach(field => {
          if (field !== this.serverOptions.groupByField && field !== this.serverOptions.groupedFieldArray.fieldName) {
            newGroup[field] = curr[field];
          }
        });
        acc.push(newGroup);
      }
      return acc;
    }, []);


    // Converte l'oggetto raggruppato in un array di oggetti
    this.options = Object.assign([], groupedData);
    // Mostra il dropdown quando ci sono nuove opzioni
    this.showDropdown();
  }

  rerender() {
    this.show.element = false;
    var self = this;
    setTimeout(function () {
      self.show.element = true;
    }, 100)
  }
performValidation(): void {
  this.valid = true;
  this.errorMessage = '';

  let hasValue = false;

  if (
    this.fieldModel !== null &&
    this.fieldModel !== undefined &&
    this.fieldModel !== '' &&
    !(typeof this.fieldModel === 'string' && this.fieldModel.trim().length === 0)
  ) {
    hasValue = true;
  }

  // 🔴 Campo obbligatorio
  if (this.required && !hasValue) {
    this.valid = false;
    this.errorMessage = 'Valore obbligatorio';
  }

  // 🟡 Validazioni numeriche
  if (this.valid && hasValue && this.type === 'number') {
    const value = Number(this.fieldModel);

    if (isNaN(value)) {
      this.valid = false;
      this.errorMessage = 'Il valore inserito non è un numero valido';
    } else if (this.minValue != null && value < this.minValue) {
      this.valid = false;
      this.errorMessage = 'Valore minimo non raggiunto';
    } else if (this.maxValue != null && value > this.maxValue) {
      this.valid = false;
      this.errorMessage = 'Valore massimo superato';
    }
  }

  // 🟢 Validazioni stringhe
  if (
    this.valid &&
    hasValue &&
    (this.type === 'string' || this.type === 'textarea')
  ) {
    const trimmedValue = this.fieldModel.toString().trim();

    if (this.minLength && trimmedValue.length < this.minLength) {
      this.valid = false;
      this.errorMessage = 'Lunghezza minima non raggiunta';
    } else if (this.maxLength && trimmedValue.length > this.maxLength) {
      this.valid = false;
      this.errorMessage = 'Lunghezza massima superata';
    }
  }

  // 🟣 Validazione regex (solo se valorizzato)
  if (this.valid && hasValue && this.pattern) {
    const regex = new RegExp(this.pattern);

    if (!regex.test(this.fieldModel.toString())) {
      this.valid = false;
      this.errorMessage = 'Formato campo non valido';
    }
  }
}

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/form-fields/form-fields.component.ts